<template>
  <div class="max-w-7xl mx-auto px-4 py-8">
    <div class="mb-6 space-y-2">
      <USkeleton class="h-4 w-40" />
      <USkeleton class="h-9 w-2/3 max-w-md" />
      <USkeleton class="h-4 w-32" />
    </div>

    <div class="grid grid-cols-1 gap-8 lg:grid-cols-2">
      <USkeleton class="aspect-[4/5] w-full rounded-xl" />
      <div class="space-y-4">
        <USkeleton class="h-4 w-24" />
        <USkeleton class="h-10 w-full max-w-lg" />
        <USkeleton class="h-8 w-40" />
        <USkeleton class="h-24 w-full max-w-md" />
        <div class="flex gap-3 pt-4">
          <USkeleton class="h-12 w-28" />
          <USkeleton class="h-12 flex-1 max-w-xs" />
        </div>
      </div>
    </div>
  </div>
</template>
